module.exports = __webpack_public_path__ + "img/GW.4fced942.svg";